module.exports = __webpack_public_path__ + "img/footer logo.e8ef8e65.svg";